export interface CatalogPermissionSecondaryCategoryConfigConstructor {
  id: number
  name: string
  primaryCategoryName: string
  grantedUserIds: number[]
}

export class CatalogPermissionSecondaryCategoryConfig {
  readonly id: number
  readonly name: string
  readonly primaryCategoryName: string
  readonly grantedUserIds: number[]

  constructor(data: CatalogPermissionSecondaryCategoryConfigConstructor) {
    this.id = data.id
    this.name = data.name
    this.primaryCategoryName = data.primaryCategoryName
    this.grantedUserIds = data.grantedUserIds
  }

  get nameWithPrimaryCategory(): string {
    return this.primaryCategoryName
      ? `${this.primaryCategoryName} - ${this.name}`
      : this.name
  }

  isUserGranted(userId: number): boolean {
    return this.grantedUserIds.includes(userId)
  }
}
